import { Card } from "antd";
import Meta from "antd/es/card/Meta";

export default function CardButton({title, icon, onClick}) {
    return (
        <Card
        title={<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}>{icon}</div>}
        onClick={onClick}
        style={{cursor: 'pointer', width: '100%',marginBottom: 20}}
        >
            <Meta title={
                <div style={{textAlign: 'center'}}>{title}</div>
            } />
        </Card>
    )
}